// ** Redux Imports
import { combineReducers } from 'redux'

import fetchUsers from './users/index'
const rootReducer = combineReducers({
  fetchUsers
})

export default rootReducer
